export { default } from './PartnerSandboxAlert';
